import React from 'react';
import './Footer.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeart, faEnvelope, faPhone, faMapMarkerAlt, faGlobe } from '@fortawesome/free-solid-svg-icons';
import { faFacebook, faTwitter, faInstagram, faLinkedin, faYoutube } from '@fortawesome/free-brands-svg-icons';

const Footer = () => {
  return (
    <footer className="relative bg-gradient-to-br from-gray-900 via-purple-900 to-indigo-900 text-white overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-0 left-0 w-96 h-96 bg-purple-500 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-pink-500 rounded-full blur-3xl"></div>
      </div>

      <div className="relative">
        {/* Main Footer Content */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
            {/* About Section */}
            <div className="space-y-4 centered">
              {/* <h3 className="text-2xl font-bold bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent">
                YouthFP
              </h3>
              <p className="text-gray-300 text-sm leading-relaxed">
                Organisation de jeunesse dédiée à la promotion de la santé sexuelle et reproductive des adolescents et jeunes au Cameroun.
              </p> */}
              {/* <div className="flex gap-3">
                <a href="#" className="w-10 h-10 bg-white/10 hover:bg-gradient-to-r hover:from-purple-500 hover:to-pink-500 rounded-full flex items-center justify-center transition-all duration-300 transform hover:scale-110">
                  <FontAwesomeIcon icon={faFacebook} />
                </a>
                <a href="#" className="w-10 h-10 bg-white/10 hover:bg-gradient-to-r hover:from-purple-500 hover:to-pink-500 rounded-full flex items-center justify-center transition-all duration-300 transform hover:scale-110">
                  <FontAwesomeIcon icon={faTwitter} />
                </a>
                <a href="#" className="w-10 h-10 bg-white/10 hover:bg-gradient-to-r hover:from-purple-500 hover:to-pink-500 rounded-full flex items-center justify-center transition-all duration-300 transform hover:scale-110">
                  <FontAwesomeIcon icon={faInstagram} />
                </a>
                <a href="#" className="w-10 h-10 bg-white/10 hover:bg-gradient-to-r hover:from-purple-500 hover:to-pink-500 rounded-full flex items-center justify-center transition-all duration-300 transform hover:scale-110">
                  <FontAwesomeIcon icon={faLinkedin} />
                </a>
                <a href="#" className="w-10 h-10 bg-white/10 hover:bg-gradient-to-r hover:from-purple-500 hover:to-pink-500 rounded-full flex items-center justify-center transition-all duration-300 transform hover:scale-110">
                  <FontAwesomeIcon icon={faYoutube} />
                </a>
              </div> */}
            </div>

            {/* Quick Links */}
            {/* <div className="space-y-4">
              <h3 className="text-xl font-bold mb-4">Liens Rapides</h3>
              <ul className="space-y-2">
                <li>
                  <a href="#" className="text-gray-300 hover:text-purple-400 transition-colors duration-300 flex items-center gap-2 group">
                    <span className="w-0 group-hover:w-2 h-0.5 bg-purple-400 transition-all duration-300"></span>
                    À Propos
                  </a>
                </li>
                <li>
                  <a href="#" className="text-gray-300 hover:text-purple-400 transition-colors duration-300 flex items-center gap-2 group">
                    <span className="w-0 group-hover:w-2 h-0.5 bg-purple-400 transition-all duration-300"></span>
                    Nos Services
                  </a>
                </li>
                <li>
                  <a href="#" className="text-gray-300 hover:text-purple-400 transition-colors duration-300 flex items-center gap-2 group">
                    <span className="w-0 group-hover:w-2 h-0.5 bg-purple-400 transition-all duration-300"></span>
                    Centres USRAJ
                  </a>
                </li>
                <li>
                  <a href="#" className="text-gray-300 hover:text-purple-400 transition-colors duration-300 flex items-center gap-2 group">
                    <span className="w-0 group-hover:w-2 h-0.5 bg-purple-400 transition-all duration-300"></span>
                    Articles
                  </a>
                </li>
                <li>
                  <a href="#" className="text-gray-300 hover:text-purple-400 transition-colors duration-300 flex items-center gap-2 group">
                    <span className="w-0 group-hover:w-2 h-0.5 bg-purple-400 transition-all duration-300"></span>
                    Galerie
                  </a>
                </li>
              </ul>
            </div> */}

            
            {/* <div className="space-y-4">
              <h3 className="text-xl font-bold mb-4">Contactez-nous</h3>
              <ul className="space-y-3">
                <li className="flex items-start gap-3 text-gray-300">
                  <FontAwesomeIcon icon={faMapMarkerAlt} className="text-purple-400 mt-1 flex-shrink-0" />
                  <span className="text-sm">Yaoundé, Cameroun</span>
                </li>
                <li className="flex items-center gap-3 text-gray-300">
                  <FontAwesomeIcon icon={faPhone} className="text-purple-400 flex-shrink-0" />
                  <span className="text-sm">+237 XXX XXX XXX</span>
                </li>
                <li className="flex items-center gap-3 text-gray-300">
                  <FontAwesomeIcon icon={faEnvelope} className="text-purple-400 flex-shrink-0" />
                  <span className="text-sm">contact@youthfp.org</span>
                </li>
                <li className="flex items-center gap-3 text-gray-300">
                  <FontAwesomeIcon icon={faGlobe} className="text-purple-400 flex-shrink-0" />
                  <span className="text-sm">www.youthfp.org</span>
                </li>
              </ul>
            </div>

            {/* Financeur - Highlighted Section */}
            <div className="space-y-4 centered">
             <div className="bg-gradient-to-br from-purple-500/20 to-pink-500/20 backdrop-blur-sm border border-purple-400/30 rounded-2xl p-6 transform hover:scale-105 transition-all duration-300 shadow-xl">
                <div className="text-center space-y-3">
                  <div className="w-16 h-16 mx-auto bg-white rounded-full flex items-center justify-center shadow-lg">
                    <img src="/images/pngegg.png" alt="AfriYan Logo" />
                  </div>
                  <h4 className="text-2xl font-extrabold bg-gradient-to-r from-purple-300 via-pink-300 to-purple-300 bg-clip-text text-transparent">
                    UNFPA CAMEROUN
                  </h4>
                  <p className="text-xs text-gray-300 leading-relaxed">
                    Partenaire Technique et Financier
                  </p>
                  {/* <div className="pt-2">
                    <span className="inline-block px-4 py-2 bg-gradient-to-r from-purple-500 to-pink-500 rounded-full text-xs font-semibold shadow-lg">
                      Partenaire Officiel
                    </span>
                  </div> */}
                </div>
              </div>
            </div>

            {/* Financeur - Highlighted Section */}
            {/* <div className="space-y-4">
             <div className="bg-gradient-to-br from-purple-500/20 to-pink-500/20 backdrop-blur-sm border border-purple-400/30 rounded-2xl p-6 transform hover:scale-105 transition-all duration-300 shadow-xl">
                <div className="text-center space-y-3">
                  <div className="w-16 h-16 mx-auto bg-white rounded-full flex items-center justify-center shadow-lg">
                    <img src="/images/logo/logoafriyan.png" alt="AfriYan Logo" />
                  </div>
                  <h4 className="text-2xl font-extrabold bg-gradient-to-r from-purple-300 via-pink-300 to-purple-300 bg-clip-text text-transparent">
                    AfriYan CAMEROUN
                  </h4>
                  <p className="text-xs text-gray-300 leading-relaxed">
                    Concepteur et développeur de la plateforme YouthFP
                  </p>
                </div>
              </div>
            </div> */}
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
            <div className="flex flex-col md:flex-row justify-between items-center gap-4">
              <div className="text-center md:text-left">
                <p className="text-gray-400 text-sm">
                  &copy; {new Date().getFullYear()} <span className="font-semibold bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent">YouthFP</span> - Tous droits réservés
                </p>
              </div>
              <div className="flex items-center gap-2 text-sm text-gray-400">
                <span>Développée par les jeunes et pour les jeunes. </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 